import { Link } from 'react-router-dom'
import { RiMenu2Fill } from 'react-icons/ri'

import logo from '../../assets/logo/logo.png'

import DropdownUser from './DropdownUser'

const Header = (props) => {
  return (
    <header className='sticky top-0 z-[999] w-full flex shadow-sm border-b bg-white'>
      <div className=' flex flex-grow items-center lg:justify-end justify-between shadow-2 py-4 px-4'>
        <div className='flex items-center gap-4 lg:hidden'>
          <button
            aria-controls='sidebar'
            onClick={(e) => {
              e.stopPropagation()
              props.setSidebarOpen(!props.sidebarOpen)
            }}
            className='z-[99999] block lg:hidden'
          >
            <RiMenu2Fill className='w-6 h-6' />
          </button>
          <Link className='block flex-shrink-0 lg:hidden' to='/'>
            <img src={logo} className='h-10 invert' alt='logo' />
          </Link>
        </div>
        <div>
          <DropdownUser />
        </div>
      </div>
    </header>
  )
}

export default Header
